// Current sponsors for Thunder Dragon FC.
// Logos are imported from the Images folder.

import JAAMLogo from '../Images/JAAM.jpg';
import DynamoLogo from '../Images/DYNAMO.png';
import CarePeopleLogo from '../Images/CarePeopleAustralia.jpg';

export const sponsors = [
  {
    id: 1,
    name: 'JAAM NEPALI BAZAAR',
    logo: JAAMLogo,
    description:
      'Proud supporter of Thunder Dragon FC, helping connect our community through authentic Nepali products and cultural experiences.'
  },
  {
    id: 2,
    name: 'Dynamo Estate Agents',
    logo: DynamoLogo,
    description:
      'Trusted real estate professionals backing Thunder Dragon FC and supporting our players, families, and local community.'
  },
  {
    id: 3,
    name: 'Care People Australia',
    logo: CarePeopleLogo,
    description:
      'Dedicated care and support services provider proudly sponsoring Thunder Dragon FC and promoting wellbeing in our community.'
  }
];
